import { Button } from '@design/components/button/Button';
import clsx from 'clsx';
import { ReactNode } from 'react';

import styles from './NoDataFound.module.scss';

export interface NoDataFoundProps {
  bannerPath: string;
  title?: string;
  description?: string;
  buttonLabel?: string;
  buttonAction?: () => void;
  buttonTestId?: string;
  children?: ReactNode;
  className?: string;
}

export const NoDataFound = ({
  bannerPath,
  title,
  description,
  buttonLabel,
  buttonAction,
  buttonTestId,
  children,
  className,
  ...rest
}: NoDataFoundProps) => {
  return (
    <div className={clsx(styles.emptyPortfolioWrapper, className)} {...rest}>
      <img className={styles.styledImg} src={bannerPath} />
      <span data-title className={styles.title}>
        {title}
      </span>
      <span className={styles.description}>{description}</span>
      {buttonAction && (
        <Button
          className={styles.addAssetsButton}
          {...(buttonTestId ? { 'data-testid': buttonTestId } : {})}
          onClick={buttonAction}
          label={buttonLabel}
        />
      )}
      {children}
    </div>
  );
};
